(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swx-new-drop"] && !Shopify.designMode) return;
  try {
    
(function () {
  var section = document.querySelector('.swx-nd');
  if (!section) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var cards = Array.prototype.slice.call(section.querySelectorAll('.swx-nd__card'));
  var rect  = section.getBoundingClientRect();

  /* Only apply IntersectionObserver when section starts below the fold */
  if (rect.top < window.innerHeight * 0.9 || !('IntersectionObserver' in window)) return;

  cards.forEach(function (c) { c.classList.add('is-waiting'); });

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.remove('is-waiting');
      entry.target.classList.add('is-visible');
      io.unobserve(entry.target);
    });
  }, { threshold: 0.1 });

  cards.forEach(function (c) { io.observe(c); });
})();

  } catch(e) { console.error(e); }
})();
})();
